<template>
    <img loading="lazy" :src="getImage()" alt="" class="image-503">
</template>
<script>

export default {
    props:["weight","desiredWeight"],
    methods:{
		getWeight(val){
			return parseInt(this.weight - (this.weight * .037 * val)).toFixed(0)
		},
        getImage(){
            const svg =  `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="-652.8 204.9 1080 672" style="enable-background:new -652.8 204.9 1080 672;" xml:space="preserve">
<style type="text/css">
	.st0{opacity:0.69;clip-path:url(#XMLID_16_);fill:url(#XMLID_17_);}
	.st1{clip-path:url(#XMLID_16_);}
	.st2{fill:#AAAAAA;}
	.st3{clip-path:url(#XMLID_16_);fill:url(#SVGID_1_);}
	.st4{fill:#E9FF86;}
	.st5{fill:#FFFFFF;}
	.st6{font-family:'Mulish';}
	.st7{font-size:69px;}
	.st8{font-size:36px;}
	.st9{font-family:'Mulish';}
	.st10{font-size:33px;}
</style>
<g id="XMLID_22_">
	<defs>
		<rect id="XMLID_21_" x="-652.8" y="204.9" width="1080" height="672"/>
	</defs>
	<clipPath id="XMLID_16_">
		<use xlink:href="#XMLID_21_"  style="overflow:visible;"/>
	</clipPath>
	<linearGradient id="XMLID_17_" gradientUnits="userSpaceOnUse" x1="-652.75" y1="573.67" x2="427.25" y2="573.67">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
		<stop  offset="1" style="stop-color:#80FFFF"/>
	</linearGradient>
	<path id="XMLID_32_" class="st0" d="M-652.8,350.6c0,0,191.2-32.4,420.6,89.7S16.1,738.8,427.2,738.8v61.8h-1080V350.6z"/>
	<g id="XMLID_9_" class="st1">
		<rect x="-493" y="205.2" class="st2" width="2" height="10.5"/>
		<path class="st2" d="M-491,806.3h-2v-20.7h2V806.3z M-491,776.7h-2v-20.7h2V776.7z M-491,747.2h-2v-20.7h2V747.2z M-491,717.7h-2
			V697h2V717.7z M-491,688.1h-2v-20.7h2V688.1z M-491,658.6h-2v-20.7h2V658.6z M-491,629.1h-2v-20.7h2V629.1z M-491,599.6h-2v-20.7
			h2V599.6z M-491,570h-2v-20.7h2V570z M-491,540.5h-2v-20.7h2V540.5z M-491,511h-2v-20.7h2V511z M-491,481.4h-2v-20.7h2V481.4z
			 M-491,451.9h-2v-20.7h2V451.9z M-491,422.4h-2v-20.7h2V422.4z M-491,392.9h-2v-20.7h2V392.9z M-491,363.3h-2v-20.7h2V363.3z
			 M-491,333.8h-2v-20.7h2V333.8z M-491,304.3h-2v-20.7h2V304.3z M-491,274.8h-2v-20.7h2V274.8z M-491,245.2h-2v-20.7h2V245.2z"/>
		<rect x="-493" y="815.1" class="st2" width="2" height="10.5"/>
	</g>
	<g id="XMLID_15_" class="st1">
		<rect x="-233.2" y="205.2" class="st2" width="2" height="10.5"/>
		<path class="st2" d="M-231.2,806.3h-2v-20.7h2V806.3z M-231.2,776.7h-2v-20.7h2V776.7z M-231.2,747.2h-2v-20.7h2V747.2z
			 M-231.2,717.7h-2V697h2V717.7z M-231.2,688.1h-2v-20.7h2V688.1z M-231.2,658.6h-2v-20.7h2V658.6z M-231.2,629.1h-2v-20.7h2V629.1
			z M-231.2,599.6h-2v-20.7h2V599.6z M-231.2,570h-2v-20.7h2V570z M-231.2,540.5h-2v-20.7h2V540.5z M-231.2,511h-2v-20.7h2V511z
			 M-231.2,481.4h-2v-20.7h2V481.4z M-231.2,451.9h-2v-20.7h2V451.9z M-231.2,422.4h-2v-20.7h2V422.4z M-231.2,392.9h-2v-20.7h2
			V392.9z M-231.2,363.3h-2v-20.7h2V363.3z M-231.2,333.8h-2v-20.7h2V333.8z M-231.2,304.3h-2v-20.7h2V304.3z M-231.2,274.8h-2
			v-20.7h2V274.8z M-231.2,245.2h-2v-20.7h2V245.2z"/>
		<rect x="-233.2" y="815.1" class="st2" width="2" height="10.5"/>
	</g>
	<g id="XMLID_13_" class="st1">
		<rect x="6.5" y="205.2" class="st2" width="2" height="10.5"/>
		<path class="st2" d="M8.5,806.3h-2v-20.7h2V806.3z M8.5,776.7h-2v-20.7h2V776.7z M8.5,747.2h-2v-20.7h2V747.2z M8.5,717.7h-2V697
			h2V717.7z M8.5,688.1h-2v-20.7h2V688.1z M8.5,658.6h-2v-20.7h2V658.6z M8.5,629.1h-2v-20.7h2V629.1z M8.5,599.6h-2v-20.7h2V599.6z
			 M8.5,570h-2v-20.7h2V570z M8.5,540.5h-2v-20.7h2V540.5z M8.5,511h-2v-20.7h2V511z M8.5,481.4h-2v-20.7h2V481.4z M8.5,451.9h-2
			v-20.7h2V451.9z M8.5,422.4h-2v-20.7h2V422.4z M8.5,392.9h-2v-20.7h2V392.9z M8.5,363.3h-2v-20.7h2V363.3z M8.5,333.8h-2v-20.7h2
			V333.8z M8.5,304.3h-2v-20.7h2V304.3z M8.5,274.8h-2v-20.7h2V274.8z M8.5,245.2h-2v-20.7h2V245.2z"/>
		<rect x="6.5" y="815.1" class="st2" width="2" height="10.5"/>
	</g>
	<g id="XMLID_1_" class="st1">
		<rect x="252.2" y="205.2" class="st2" width="2" height="10.5"/>
		<path class="st2" d="M254.2,806.3h-2v-20.7h2V806.3z M254.2,776.7h-2v-20.7h2V776.7z M254.2,747.2h-2v-20.7h2V747.2z M254.2,717.7
			h-2V697h2V717.7z M254.2,688.1h-2v-20.7h2V688.1z M254.2,658.6h-2v-20.7h2V658.6z M254.2,629.1h-2v-20.7h2V629.1z M254.2,599.6h-2
			v-20.7h2V599.6z M254.2,570h-2v-20.7h2V570z M254.2,540.5h-2v-20.7h2V540.5z M254.2,511h-2v-20.7h2V511z M254.2,481.4h-2v-20.7h2
			V481.4z M254.2,451.9h-2v-20.7h2V451.9z M254.2,422.4h-2v-20.7h2V422.4z M254.2,392.9h-2v-20.7h2V392.9z M254.2,363.3h-2v-20.7h2
			V363.3z M254.2,333.8h-2v-20.7h2V333.8z M254.2,304.3h-2v-20.7h2V304.3z M254.2,274.8h-2v-20.7h2V274.8z M254.2,245.2h-2v-20.7h2
			V245.2z"/>
		<rect x="252.2" y="815.1" class="st2" width="2" height="10.5"/>
	</g>
	<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-660.375" y1="542.7757" x2="427.25" y2="542.7757">
		<stop  offset="0" style="stop-color:#ED0000"/>
		<stop  offset="0.452" style="stop-color:#FFFF00"/>
		<stop  offset="1" style="stop-color:#00FF00"/>
	</linearGradient>
	<path class="st3" d="M427.2,744.3c-129.6,0-228.5-17-311.2-53.4c-73.8-32.5-125-76.2-179.3-122.5c-49.2-41.9-100-85.2-171.5-123.3
		c-117.5-62.5-224.6-83.4-293.8-90c-75-7.1-122.8,0.7-123.3,0.8l-6.8,1.1l-1.8-10.9l6.8-1.1c1.9-0.3,49.3-8.1,125.7-1
		c44.7,4.2,90.1,12.7,134.8,25.3c55.9,15.7,110.9,37.9,163.6,65.9c72.6,38.6,123.9,82.3,173.5,124.6
		C-2.4,605.8,48.2,649,120.5,680.9c81.2,35.8,178.7,52.5,306.7,52.5V744.3z"/>
	<g class="st1">
		<circle id="XMLID_27_" class="st4" cx="-493" cy="353.3" r="24.3"/>
		<path id="XMLID_14_" d="M-493,337c9,0,16.3,7.3,16.3,16.3c0,9-7.3,16.3-16.3,16.3s-16.3-7.3-16.3-16.3
			C-509.3,344.3-502,337-493,337 M-493,329c-13.4,0-24.3,10.9-24.3,24.3c0,13.4,10.9,24.3,24.3,24.3c13.4,0,24.3-10.9,24.3-24.3
			C-468.7,339.9-479.6,329-493,329L-493,329z"/>
	</g>
	<g class="st1">
		<circle id="XMLID_25_" class="st4" cx="-232.2" cy="443.9" r="24.3"/>
		<path id="XMLID_11_" d="M-232.2,427.6c9,0,16.3,7.3,16.3,16.3s-7.3,16.3-16.3,16.3s-16.3-7.3-16.3-16.3S-241.1,427.6-232.2,427.6
			 M-232.2,419.6c-13.4,0-24.3,10.9-24.3,24.3s10.9,24.3,24.3,24.3s24.3-10.9,24.3-24.3S-218.8,419.6-232.2,419.6L-232.2,419.6z"/>
	</g>
	<g class="st1">
		<circle id="XMLID_24_" class="st4" cx="7.5" cy="622.1" r="24.3"/>
		<path id="XMLID_7_" d="M7.5,605.9c9,0,16.3,7.3,16.3,16.3s-7.3,16.3-16.3,16.3s-16.3-7.3-16.3-16.3S-1.4,605.9,7.5,605.9
			 M7.5,597.9c-13.4,0-24.3,10.9-24.3,24.3s10.9,24.3,24.3,24.3s24.3-10.9,24.3-24.3S20.9,597.9,7.5,597.9L7.5,597.9z"/>
	</g>
	<g class="st1">
		<circle id="XMLID_23_" class="st4" cx="253.2" cy="728.5" r="24.3"/>
		<path id="XMLID_2_" d="M253.2,712.2c9,0,16.3,7.3,16.3,16.3c0,9-7.3,16.3-16.3,16.3s-16.3-7.3-16.3-16.3
			C236.9,719.5,244.2,712.2,253.2,712.2 M253.2,704.2c-13.4,0-24.3,10.9-24.3,24.3c0,13.4,10.9,24.3,24.3,24.3
			c13.4,0,24.3-10.9,24.3-24.3C277.5,715.1,266.6,704.2,253.2,704.2L253.2,704.2z"/>
	</g>
	<g id="XMLID_12_" class="st1">
		<g id="XMLID_58_">
			<rect x="-601.7" y="251.2" class="st5" width="220.2" height="59.2"/>
		</g>
		<text id="XMLID_59_" transform="matrix(1 0 0 1 -586.6552 301.4536)"><tspan x="0" y="0" class="st6 st7">${this.weight}</tspan><tspan x="116.8" y="0" class="st6 st8"> Lbs</tspan></text>
	</g>
	<g id="XMLID_42_" class="st1">
		<g id="XMLID_62_">
			<rect x="-329.9" y="310.4" class="st5" width="207.8" height="75.6"/>
		</g>
		<text id="XMLID_60_" transform="matrix(1 0 0 1 -330.753 368.9247)"><tspan x="0" y="0" class="st6 st7">${this.getWeight(1)}</tspan><tspan x="123.9" y="0" class="st6 st8"> Lbs</tspan></text>
	</g>
	<g id="XMLID_63_" class="st1">
		<g id="XMLID_74_">
			<rect x="-96.4" y="443.9" class="st5" width="207.8" height="75.6"/>
		</g>
		<text id="XMLID_64_" transform="matrix(1 0 0 1 -95.0022 502.4087)"><tspan x="0" y="0" class="st6 st7">${this.getWeight(2)}</tspan><tspan x="119.4" y="0" class="st6 st8"> Lbs</tspan></text>
	</g>
	<g id="XMLID_40_" class="st1">
		<g id="XMLID_57_">
			<rect x="149.3" y="608.6" class="st5" width="207.8" height="75.6"/>
		</g>
		<text id="XMLID_56_" transform="matrix(1 0 0 1 149.6818 667.1206)"><tspan x="0" y="0" class="st6 st7">${this.getWeight(6)}</tspan><tspan x="121.4" y="0" class="st6 st8"> Lbs</tspan></text>
	</g>
	<rect x="-652.8" y="798.1" class="st1" width="1080" height="5"/>
	<g id="XMLID_10_" class="st1">
		<text transform="matrix(1 0 0 1 -557.2375 868.2)" class="st9 st10">Month 1</text>
	</g>
	<g id="XMLID_342_" class="st1">
		<text transform="matrix(1 0 0 1 -300.8832 868.2)" class="st9 st10">Month 2</text>
	</g>
	<g id="XMLID_343_" class="st1">
		<text transform="matrix(1 0 0 1 -60.4846 868.2)" class="st9 st10">Month 3</text>
	</g>
	<g id="XMLID_341_" class="st1">
		<text transform="matrix(1 0 0 1 183.9443 868.2)" class="st9 st10">Month 6</text>
	</g>
</g>
</svg>`
return 'data:image/svg+xml,' + encodeURIComponent(svg);
        }
    },
}
</script>